import { useEffect, useState } from 'react';

import { TIME } from '@repo/common';

function secondsUntil(availableAt: Date | undefined): number {
  if (!availableAt) {
    return 0;
  }
  return Math.max(0, Math.ceil((availableAt.getTime() - Date.now()) / TIME.MILLISECONDS.PER_SECOND));
}

/** Whole seconds until `availableAt`, ticking once a second until it reaches zero. */
export const useResendCountdown = (availableAt: Date | undefined): number => {
  const [remaining, setRemaining] = useState(() => secondsUntil(availableAt));

  useEffect(() => {
    setRemaining(secondsUntil(availableAt));
    if (secondsUntil(availableAt) === 0) {
      return undefined;
    }
    const timer = setInterval(() => {
      const next = secondsUntil(availableAt);
      setRemaining(next);
      if (next === 0) {
        clearInterval(timer);
      }
    }, TIME.MILLISECONDS.PER_SECOND);
    return () => clearInterval(timer);
  }, [availableAt]);

  return remaining;
};
